import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  roles: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      if (action.payload.user) {
        state.user = action.payload.user;
        state.roles = Array.isArray(action.payload.user.roles)
          ? action.payload.user.roles.map((role) => (typeof role === 'string' ? role : role?.name)).filter(Boolean)
          : state.roles;
      }

      if (action.payload.token !== undefined) {
        state.token = action.payload.token;
      }

      state.error = null;
    },
    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.roles = [];
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setUser, clearUser, setLoading, setError } = authSlice.actions;
export default authSlice.reducer;
